
import Vue from 'vue';
import type { LoginLandingVariant } from './loginLandingVariants';

export default Vue.extend({
	name: 'LoginLandingLeftPanel',
	props: {
		variant: {
			type: Object,
			required: true,
		} as any as { type: () => LoginLandingVariant, required: true },
	},
});
